export default (el) => {
    var mapElement = document.getElementById(el);

    if(mapElement) {
        google.maps.event.addDomListener(window, 'load', init);
        function init() {
            var mapOptions = {
                zoom: 				15,
                scrollwheel: 		false,		
                streetViewControl: 	false,
                mapTypeControl:		false,
                center: new google.maps.LatLng(52.370224, 4.627572),
                styles: [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#98458a"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#e2e2e2"},{"visibility":"on"}]}]
            };
            var map = new google.maps.Map(mapElement, mapOptions);
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(52.371817, 4.627572),
                map: map,
                title: 'AVT Benelux!'
            });
        }
    }
}